import React from 'react';
import { Routes, Route, Link } from 'react-router-dom'
import Button from '@material-ui/core/Button';
import AppBar from '@material-ui/core/AppBar';

import SubmitForm from './SubmitForm'
import Results from './Results'
import About from './About'
import ErrorPage from '../NoModel/ErrorPage'

class CMAQPage extends React.Component {

    render() {
        return (
            <div>
                <header className='landingpage-header'>
                    <div className='title-container'>
                        <h1 >AQcast: CMAQ </h1>
                    </div>
                </header>

                <nav className='navContainer'>
                    <AppBar className='navBar' color='inherit' position="static">
                        <div>
                            <Button className='navBarBtn-3' component={Link} to='/CMAQ/SubmitForm'>Submit</Button>
                            <Button className='navBarBtn-3' component={Link} to='/CMAQ/Results'>Results</Button>
                            <Button className='navBarBtn-3' component={Link} to='/CMAQ/About'>About</Button>
                        </div>
                    </AppBar>
                </nav>

                <main className='main'>
                    <Routes>
                        <Route path='*'>
                            <Route index element={<SubmitForm/>}/>
                            <Route path='SubmitForm' element={<SubmitForm/>}/>
                            <Route path='Results' element={<Results/>}/>
                            <Route path='About' element={<About/>}/>
                        </Route>
                        <Route path='*' element={<ErrorPage/>}/>
                    </Routes>
                </main>
            </div>
        );
    }
}

export default CMAQPage;
